import { render, staticRenderFns } from "./DeregisterForm.vue?vue&type=template&id=7003b3ff&"
import script from "./DeregisterForm.vue?vue&type=script&lang=js&"
export * from "./DeregisterForm.vue?vue&type=script&lang=js&"
import style0 from "./DeregisterForm.vue?vue&type=style&index=0&id=7003b3ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QInput,QField,QBtn});
